import React, {
  RefObject,
} from 'react';
import Button from 'pages/Dashboard/components/Button';
import Overview from 'pages/Dashboard/pages/Fax/Overview';
import {
  FaxIcon,
} from 'core/icons';
import {
  useFilterQueryWithDateRange,
  useTableReset,
} from 'core/hooks';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import DateRangePicker from 'core/components/DateTimePicker/DateRangePicker';
import {
  faxEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import SearchInput from 'pages/Dashboard/components/SearchInput';
import {
  useSyncSearchQuery,
} from 'pages/Dashboard/hooks/url';
import SearchIcon from 'core/icons/search';
import Filters from 'core/Filters';
import {
  EFaxFilterDTO,
} from 'dtos';

export default function Fax() {
  const { reset, tableInstanceRef } = useTableReset();
  const {
    searchQuery,
    setSearchQuery,
  } = useSyncSearchQuery();
  const {
    filterQuery,
    setFilterQuery,
    filterInstanceRef,
    dateRange,
    setDateRange,
  } = useFilterQueryWithDateRange<EFaxFilterDTO>(
    'eFax',
    { uniqueKey: 'eFaxRange' },
    true,
  );
  const onFilterUpdate = () => {
    setFilterQuery(filterInstanceRef?.current?.getFilterQuery?.() ?? {});
    reset();
  };

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center mb-4 px-4 justify-between">
        <div className="flex flex-row gap-4">
          <SearchInput
            placeholder="Enter Sender, Recipient or Patient Name"
            className="w-96"
            value={searchQuery}
            onChange={(val) => {
              setSearchQuery(val);
              reset();
            }}
            inputProps={{
              autoComplete: 'off',
            }}
            icon={<SearchIcon className="!w-4 !h-4 text-gray-400" />}
            id="patient-search"
          />
          <DateRangePicker
            value={dateRange}
            onChange={(nextDateRange) => {
              if (nextDateRange) {
                setDateRange(nextDateRange);
                reset();
              }
            }}
          />
          <Filters
            pageObject="eFax"
            onFilterUpdate={onFilterUpdate}
            instanceRef={filterInstanceRef}
            useStorage
          />
        </div>
        <Button
          className="!h-8"
          variant="contained"
          type="button"
          color="primary"
          startIcon={<FaxIcon className="!w-4 !h-4" />}
          onClick={() => {
            faxEventChannel.emit('onOpenSendFax', {});
          }}
        >
          Send Fax
        </Button>
      </div>
      <Overview
        dateRange={dateRange}
        filterQuery={filterQuery}
        searchQuery={searchQuery}
        tableInstanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
      />
    </div>
  );
}
